import React from 'react';
import { FastField, Field, type FieldProps } from 'formik';
import KoobInputCheckbox from '../KoobInputCheckbox';

type KoobInputCheckboxFieldProps = {
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  /** Show the error before the field is touched when false */
  touchRequired?: boolean;
  /** Use formik FastField (skips re-renders of untouched fields) */
  fast?: boolean;
};

export const KoobInputCheckboxField = ({
  name,
  label,
  disabled,
  size,
  touchRequired = true,
  fast = false,
}: KoobInputCheckboxFieldProps) => {
  const FieldComponent = fast ? FastField : Field;

  return (
    <FieldComponent name={name}>
      {({ field, meta, form }: FieldProps) => {
        const hasError = touchRequired
          ? Boolean(meta.error && meta.touched)
          : Boolean(meta.error);

        return (
          <div className="flex flex-col gap-1">
            <KoobInputCheckbox
              name={name}
              label={label}
              checked={Boolean(field.value)}
              onCheckedChange={(checked) => form.setFieldValue(name, checked)}
              onBlur={field.onBlur}
              disabled={disabled}
              size={size}
              error={hasError}
              data-testid={`checkbox-${name}`}
            />
            {hasError && (
              <p className="m-0 text-sm text-red-500">{meta.error}</p>
            )}
          </div>
        );
      }}
    </FieldComponent>
  );
};

export default KoobInputCheckboxField;
